enum GenderEnum {
    Female = 'FEMALE',
    Male = 'MALE',
}

export default GenderEnum;
